<template>
  <div class="dd-container">
    <span class="dd-system-title">
      测绘所房屋管理系统
    </span>
    <span class="dd-time">{{currentTime}}</span>
    <div class="dd-userinfo">
      <a-dropdown>
        <a
          class="ant-dropdown-link"
          @click="e => e.preventDefault()"
          :title="$store.state.user.name"
        >
          <span>
            {{this.$store.state.user.name}}
          </span>
          <a-icon type="caret-down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item
            key="0"
            @click="logout"
          >退出
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <a-divider
        type="vertical"
        v-show="false"
      />
      <div
        class="dd-android"
        v-show="false"
        @click="androidClick"
      ></div>
    </div>
    <a-row class="dd-row">
      <a-col :span="8">
        <div class="dd-abstract dd-border-image">
          <div class="dd-inner">
            <h3 class="dd-inner-h3">概况</h3>
            <p
              class="dd-inner-text"
              v-html="abstractData"
            >
            </p>
          </div>
        </div>
      </a-col>
      <a-col
        :span="16"
        class="dd-right"
      >
        <div class="dd-right-menu">
          <ul class="dd-right-ul">
            <li
              @click="$router.push('/manage')"
              v-show="$store.state.user.role_no=='001' || $store.state.user.role_no=='002'"
            >系统管理</li>
            <li @click="$router.push('/home')">查询分析</li>
          </ul>
        </div>
        <a-row class="dd-map-region">
          <a-col
            :span="24"
            id="regionMap"
          >
            <h4
              class="dd-inner-h4"
              style="text-align:right;padding-right:0.5rem;position:absolute;right:0px; z-index: 1001;"
            >房屋分布热力图</h4>
            <!-- <div
              class="dd-border-image"
              style="position: absolute;bottom: 0px;right: 0px;left: auto; height:16rem;width:47%; z-index: 1001;background: #080a20;"
            >
              <div
                class="dd-inner"
                id="mainMap"
              >
              </div>
            </div> -->
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row class="dd-row">
      <a-col :span="6">
        <div class="dd-border-image">
          <div class="dd-inner">
            <h4 class="dd-inner-h4">幢房屋用途/平米</h4>
            <!-- @click="changeLayer('jbnt')" -->
            <div
              class="dd-inner-chart"
              ref="jbntFbDiv"
            >
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="dd-border-image">
          <div class="dd-inner">
            <h4 class="dd-inner-h4">幢产别分布/平米</h4>
            <!-- @click="changeLayer('tdxz')" -->
            <div
              class="dd-inner-chart"
              ref="xzTdfbDiv"
            >
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="dd-border-image">
          <div class="dd-inner">
            <h4 class="dd-inner-h4">幢建成年代面积分布/平米</h4>
            <!-- @click="changeLayer('zllh')" -->
            <div
              class="dd-inner-chart"
              ref="zlNdfbDiv"
            >
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="dd-border-image">
          <div class="dd-inner">
            <h4 class="dd-inner-h4">幢建筑类型分布/平米</h4>
            <div
              @click="changeLayer('jjd')"
              class="dd-inner-chart"
              ref="jjdFbDiv"
            >
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import EChartsLayer from 'ol-echarts';
import "ol/ol.css";
import { Map, View } from "ol";
import * as olControl from 'ol/control';
import TileWMS from 'ol/source/TileWMS';
import Projection from 'ol/proj/Projection';
import { transform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import TileLayer from 'ol/layer/Tile';
import HeatmapLayer from 'ol/layer/Heatmap';
import proj4 from 'proj4';
import epsg9900 from '../utils/epsgParams';
import * as olProj from 'ol/proj';
import format from 'date-fns/format';
import { zhCN } from 'date-fns/locale'
import dbTool from '../utils/localDb';
import TileGrid from 'ol/tilegrid/TileGrid';
import XYZ from 'ol/source/XYZ';
import VectorSource from 'ol/source/Vector';
import { WFS, GeoJSON } from 'ol/format';




export default {
  name: "Dashboard",
  data() {
    return {
      mainMap: {},
      regionMap: {},
      geoCoordMap: {
        '智环成': [496962, 287103],
        '亦庄镇': [513160.25822443823562935, 291378.93012977932812646],
        '黄村镇': [498603.96915761637501419, 285292.04727153078420088],
        '魏善庄镇': [505091.52109961735550314, 275989.58339715097099543],
        '长子营镇': [520935.43049974541645497, 278677.72345541702816263],
        '瀛海镇': [510519.33128264179686084, 286303.91009291232330725],
        '北臧村镇': [491700.2848086969461292, 278078.56928970327135175],
        '庞各庄镇': [495243.57453899929532781, 271059.94062872091308236],
        '榆垡镇': [498382.42511147423647344, 259909.83679445763118565],
        '礼贤镇': [505220.82839281938504428, 265398.58544304582756013],
        '安定镇': [512323.15659445803612471, 272421.38269942946499214],
        '采育镇': [526391.08830601966474205, 274570.44206249580020085],
        '青云店镇': [512400.72466474951943383, 280902.66964170394930989],
        '旧宫镇': [506725.70175249350722879, 291826.91177002195036039],
        '西红门镇': [501815.66122027451638132, 288923.24032049131346866]
      },
      abstractData: "西城区，隶属于北京市，位于北京中心城区西部。东与东城区相连；北与海淀区、朝阳区毗邻；西与海淀区、丰台区接壤；南与丰台区相连。区境东西宽7.1千米，南北长11.2千米，总面积50.70平方千米。",
      ntTotal: 0,
      xzTotalArea: 59729983.33,//单位应该是平米
      currentTime: format(new Date(), "yyyy-MM-dd HH:mm:ss cccc", { locale: zhCN }),
    }
  },
  methods: {
    initRegionMap() {
      const projection = this.addProjection();

      const tileSource = new XYZ({
        maxZoom: 8,
        minZoom: 0,
        projection: projection,
        transition: 0,
        tileGrid: new TileGrid({
          tileSize: 256,
          origin: epsg9900.origin,
          extent: epsg9900.extent,
          resolutions: epsg9900.tile_resolutions
        }),
        tileUrlFunction: (tileCoord) => {
          const z = "L" + this.zeroPad(tileCoord[0], 2, 10);
          const x = "C" + this.zeroPad(tileCoord[1], 8, 16);
          const y = "R" + this.zeroPad(tileCoord[2], 8, 16);
          return `${process.env.VUE_APP_BASEMAP}/Layers/_alllayers/${z}/${y}/${x}.png`;
        }
      })
      const baseLayer = new TileLayer({
        id: "base_layer_0",
        source: tileSource,
        wrapX: true
      });

      const tileLayer = new TileLayer({
        source: new TileWMS({
          url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
          params: {
            'LAYERS': "chs:20210404184028232",
            'TILED': true
          },
          serverType: 'geoserver',
          transition: 0
        })
      });
      this.regionMap = new Map({
        target: 'regionMap',
        controls: olControl.defaults({
          zoom: false
        }),
        layers: [
          baseLayer
        ],
        view: new View({
          center: [(epsg9900.initExtent[0] + epsg9900.initExtent[2]) / 2, (epsg9900.initExtent[1] + epsg9900.initExtent[3]) / 2],
          projection: projection,
          zoom: 7,
          minZoom: 0,
          maxZoom: 20
        })
      });
      this.regionMap.getView().setCenter([502058.2, 305917.6]);

      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "chs",
        featurePrefix: "chs",
        featureTypes: ["20210404184028232"],
        outputFormat: "application/json"
      });
      this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
        const features = new GeoJSON().readFeatures(res.data);
        const vector = new HeatmapLayer({
          source: new VectorSource({
            features: features
          }),
          blur: 5,
          radius: 10,
          weight: (feature) => {
            return feature.get('房屋间数');
          },
        });
        // console.log(this.regionMap.getView().getZoom());
        this.regionMap.addLayer(vector);
      })

    },
    zeroPad(num, len, radix) {
      let str = num.toString(radix || 10);
      while (str.length < len) {
        str = "0" + str;
      }
      return str;
    },
    initMainMap() {
      const projection = this.addProjection();
      const tileLayer = new TileLayer({
        source: new TileWMS({
          url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
          params: {
            'LAYERS': "chs:20210404184028232",
            'TILED': true
          },
          serverType: 'geoserver',
          transition: 0
        })
      });
      this.mainMap = new Map({
        target: 'mainMap',
        controls: olControl.defaults({
          zoom: false
        }),
        layers: [
          tileLayer,
        ],
        view: new View({
          center: [(487898.5220950013026595 + 531793.1995240002870560) / 2, (252937.1718750018626451 + 296060.1610720008611679) / 2],
          projection: projection,
          zoom: 10
        })
      });
      this.mainMap.getView().fit([487898.5220950013, 252937.17187500186, 531793.1995240003, 296060.16107200086]);

      var echartslayer = new EChartsLayer(this.getOption(), {
        hideOnMoving: true,
        forcedRerender: false,
        forcedPrecomposeRerender: false,
        stopEvent: false,
        polyfillEvents: false
      });
      echartslayer.appendTo(this.mainMap);
    },
    getOption() {
      const BJData = [
        [{ name: '智环成' }, { name: '智环成', value: 95 }],
        [{ name: '智环成' }, { name: '亦庄镇', value: 95 }],
        [{ name: '智环成' }, { name: '黄村镇', value: 90 }],
        [{ name: '智环成' }, { name: '魏善庄镇', value: 80 }],
        [{ name: '智环成' }, { name: '长子营镇', value: 70 }],
        [{ name: '智环成' }, { name: '瀛海镇', value: 60 }],
        [{ name: '智环成' }, { name: '北臧村镇', value: 50 }],
        [{ name: '智环成' }, { name: '庞各庄镇', value: 40 }],
        [{ name: '智环成' }, { name: '榆垡镇', value: 30 }],
        [{ name: '智环成' }, { name: '礼贤镇', value: 20 }],
        [{ name: '智环成' }, { name: '采育镇', value: 10 }],
        [{ name: '智环成' }, { name: '青云店镇', value: 10 }],
        [{ name: '智环成' }, { name: '旧宫镇', value: 10 }],
        [{ name: '智环成' }, { name: '安定镇', value: 10 }],
        [{ name: '智环成' }, { name: '西红门镇', value: 10 }]
      ];
      let series = [];
      series.push({
        name: '智环成服务分布',
        type: 'lines',
        zlevel: 1,
        // symbol: 'arrow',
        effect: {
          show: true,
          period: 6,
          trailLength: 0.7,
          color: '#fff',
          symbolSize: 3
        },
        lineStyle: {
          normal: {
            color: "#a6c84c",
            width: 0,
            curveness: 0.2
          }
        },
        data: this.convertData(BJData)
      },
        {
          name: '智环成服务分布',
          type: 'lines',
          zlevel: 2,
          symbol: ['none', 'arrow'],
          symbolSize: 10,
          effect: {
            show: true,
            period: 6,
            trailLength: 0,
          },
          lineStyle: {
            normal: {
              color: "#a6c84c",
              width: 1,
              opacity: 0.4,
              curveness: 0.2
            }
          },
          data: this.convertData(BJData)
        },
        {
          name: '智环成服务分布',
          type: 'effectScatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            brushType: 'stroke'
          },
          label: {
            normal: {
              show: true,
              position: 'right',
              formatter: '{b}'
            }
          },
          symbolSize: (val) => {
            return val[2] / 8;
          },
          itemStyle: {
            normal: {
              color: "#a6c84c"
            }
          },
          data: BJData.map((dataItem) => {
            return {
              name: dataItem[1].name,
              value: transform(this.geoCoordMap[dataItem[1].name], 'EPSG:990000', 'EPSG:4326').concat([dataItem[1].value])
            };
          })
        });
      return {
        tooltip: {
          trigger: 'item'
        },
        series: series
      };
    },
    convertData(data) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        const dataItem = data[i];
        const fromCoord = transform(this.geoCoordMap[dataItem[0].name], 'EPSG:990000', 'EPSG:4326');
        const toCoord = transform(this.geoCoordMap[dataItem[1].name], 'EPSG:990000', 'EPSG:4326');
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [fromCoord, toCoord]
          });
        }
      }
      return res;
    },
    initXzJbntFb(data) {
      const myChart = echarts.init(this.$refs.jbntFbDiv);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            // return params.seriesName + "<br>" + params.name + "：" + Number(params.value).toFixed(2) + `亩(${params.percent})%`;
            return params.seriesName + "<br>" + params.name + "：" + `${params.percent}%`;
          }
        },
        series: [{
          name: '幢房屋用途占比',
          type: 'pie',
          radius: '80%',
          data: data
        }],
        color: ['#9fe6b8', '#32c5e9', '#1d9dff'],
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    initXzYjfl(data) {
      const myChart = echarts.init(this.$refs.xzTdfbDiv);
      const option = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'line'
          },
          formatter: (params) => {
            return params.seriesName + "<br>" + params.name + "：" + Number(params.value).toFixed(2) + "平米";
          }
        },
        grid: {
          top: '6%',
          right: '3%',
          bottom: '3%',
          left: '0%',
          containLabel: true,
          show: true,
          borderColor: 'rgba(0, 240, 255, 0.3)'
        },
        xAxis: [{
          type: 'category',
          data: data.map(d => d.name),
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLabel: {
            color: '#4c9bfd'
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#4c9bfd'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 240, 255, 0.3)'
            }
          }
        }],
        series: [{
          name: '幢产别分布',
          type: 'bar',
          barWidth: '60%',
          data: data,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'red'
            }, {
              offset: 1,
              color: 'blue'
            }])
          }
        }]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    initZlndfb(data) {
      const myChart = echarts.init(this.$refs.zlNdfbDiv);
      const option = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'line'
          },
          formatter: (params) => {
            return params.seriesName + "<br>" + params.name + "：" + Number(params.value).toFixed(2) + "平米";
          }
        },
        grid: {
          top: '6%',
          right: '3%',
          bottom: '3%',
          left: '0%',
          containLabel: true,
          show: true,
          borderColor: 'rgba(0, 240, 255, 0.3)'
        },
        xAxis: [{
          type: 'category',
          data: data.map(d => d.name),
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLabel: {
            color: '#4c9bfd'
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#4c9bfd'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 240, 255, 0.3)'
            }
          }
        }],
        series: [{
          name: '建成年代分布',
          type: 'line',
          barWidth: '60%',
          data: data,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'red'
            }, {
              offset: 1,
              color: 'blue'
            }])
          }
        }]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    initJjdFb(data) {
      const myChart = echarts.init(this.$refs.jjdFbDiv);
      const option = {
        color: ['#ff9f7f', '#0096ff', '#9fe6b8', '#ff0000', '#09ef20', '#0069d9', '#32c5e9', '#1d9dff'],
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return params.seriesName + "<br>" + params.name + "：" + Number(params.value).toFixed(2) + `平米(${params.percent})%`;
          }
        },
        series: [
          {
            name: '幢建筑类型分布',
            type: 'pie',
            radius: '80%',
            center: ['50%', '50%'],  // for pie
            data: data
          },
        ]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    addProjection() {
      proj4.defs('EPSG:990000', epsg9900.define);
      register(proj4);
      return new Projection({
        code: "EPSG:990000",
        units: epsg9900.units,
        extent: epsg9900.extent
      });
    },
    getAbastract() {
      this.$httpGet(`zserver/api/abstract_by_orgno?orgNo=${this.$store.state.user.org_no}`).then(res => {
        this.abstractData = res.data.content || this.abstractData;
      })
    },
    getAllStaticsData() {
      this.$httpGet(`zserver/api/all_data`).then(res => {
        if (res.data) {
          // this.ntTotal = Number(res.data.ntTotal).toFixed(2);
          this.initXzJbntFb(res.data.zhuangFangwuyt);
          this.initXzYjfl(res.data.zhuangChanbie);
          this.initZlndfb(res.data.zhuangJianchengnd);
          this.initJjdFb(res.data.zhuangJianzhulx);
          // this.initLayers(res.data.layers);
        }
      })
    },
    initLayers(layers) {
      if (layers && layers.length > 0) {
        layers.forEach(layerm => {
          this.addRelationLayer(layerm);
        })
      }
    },
    addRelationLayer(layerm) {
      if (!layerm || !layerm.layer) {
        return;
      }
      const tileLayer = new TileLayer({
        visible: layerm.tjx != "tdxz" ? false : true,
        id: `${layerm.tjx}_layer`,
        source: new TileWMS({
          url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
          params: {
            'LAYERS': "chs:" + layerm.layer,
            'TILED': true
          },
          serverType: 'geoserver',
          transition: 0
        })
      });
      this.regionMap.addLayer(tileLayer);
    },
    changeLayer(tjx) {
      ["jbnt", "tdxz", "jjd", "zllh"].forEach(it => {
        const l = this.getLayerById(`${it}_layer`);
        if (l) {
          l.setVisible(false);
        }
      })
      const l = this.getLayerById(`${tjx}_layer`);
      if (l) {
        l.setVisible(true);
      }
    },
    getLayerById(id) {
      for (let l of this.regionMap.getLayers().getArray()) {
        if (l.get("id") == id) {
          return l;
        }
      }
      return undefined;
    },
    androidClick() {
      this.$message.warn("待开发");
    },
    logout() {
      dbTool.clear();
      this.$router.push("/login");
    },
    getUserInfo() {
      this.$httpGet("zserver/api/userinfo").then(res => {
        if (res && res.data) {
          if (res.data.password) {
            delete res.data.password;
          }
          this.$store.commit("setUser", res.data)
        }
      }, err => {
        console.error(err);
      })
    },
  },
  mounted() {
    this.getAbastract();
    this.getUserInfo();
    this.nowTimer = setInterval(() => {
      this.currentTime = format(new Date(), "yyyy-MM-dd HH:mm:ss cccc", { locale: zhCN });
    }, 1000);
    this.$nextTick(() => {
      setTimeout(() => {
        // this.initMainMap();
        this.initRegionMap();
        this.getAllStaticsData();
        // this.addRelationLayer();
      }, 1000);
    })
  },
  beforeDestroy() {
    if (this.nowTimer) {
      clearInterval(this.nowTimer); // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style lang="scss" scoped>
.dd-container {
  width: 100%;
  height: 100%;
  background: rgb(13, 25, 68);
  background-image: url("../assets/background.png");
  background-repeat: no-repeat;
  background-size: 100% auto;

  & .dd-android {
    background: url(../assets/android.png);
    width: 1rem;
    height: 1rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
  }

  & .dd-time {
    position: absolute;
    top: 1.3rem;
    left: 1.3rem;
    color: #528fde;
    font-size: 0.75rem;
  }

  & .dd-userinfo {
    position: absolute;
    right: 1.3rem;
    top: 1.3rem;
    color: #528fde;
    font-size: 0.75rem;

    & span,
    i {
      color: #528fde;
      font-size: 0.75rem;
    }
  }

  & .dd-system-title {
    display: block;
    text-align: center;
    font-weight: 400;
    padding-top: 1.25rem;
    font-size: 1.3rem;
    height: 3.15rem;
    color: #84cdf4;
    // background-image: linear-gradient(#0733c2, #84cdf4);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }

  & .dd-sub-title {
    position: absolute;
    width: 100px;
    text-align: center;
    left: calc(50% - 50px);
    top: 2.8rem;
    font-size: 1rem;
    color: #84cdf4;
    // background-image: linear-gradient(#0733c2, #84cdf4);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }

  & .dd-abstract {
    height: 23rem !important;
  }
  .dd-border-image {
    box-sizing: border-box;
    border: 2px solid red;
    border-image: url(../assets/border.png) 51 38 21 132;
    border-width: 2.125rem 1.583rem 0.875rem 5.5rem;
    position: relative;
    height: 15rem;

    & > div {
      position: absolute;
      top: -2.125rem;
      left: -5.5rem;
      right: -1.583rem;
      bottom: -0.875rem;
      padding: 1rem;
      font-family: "华文中宋";

      & .dd-inner-h3 {
        font-size: 1.5rem;
        color: #fff;
      }

      & .dd-inner-chart {
        width: 100%;
        height: calc(100% - 40px);
        height: -moz-calc(100% - 40px);
        height: -webkit-calc(100% - 40px);
      }

      & .dd-inner-text {
        color: #528fde;
        font-size: 0.9rem;
        max-height: 17rem;
        overflow-y: auto;
      }
    }
  }
  .dd-inner-h4 {
    font-size: 0.9rem;
    color: #fff;
    font-family: "华文中宋";
  }
  .dd-row {
    padding: 10px 15px;
    & > div {
      padding: 5px 10px;
    }
  }
  .dd-right {
    height: 100%;
    padding-left: 20px;
  }
  & .dd-right-menu {
    width: 100%;
    height: 40px;
    display: block;
    text-align: right;

    & .dd-right-ul {
      list-style: none;
      margin-bottom: 0px;
      & > li {
        float: right;
        width: 6rem;
        height: 1.6rem;
        line-height: 1.6rem;
        list-style: none;
        background: url(../assets/btn_back.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        color: #fff;
        font-family: "华文中宋";
        font-size: 0.7rem;
        cursor: pointer;
      }
      & > li:hover {
        color: rgb(85, 83, 83);
      }
    }
  }

  .dd-map-region {
    width: 100%;
    height: calc(23rem - 40px);
    height: -moz-calc(23rem - 40px);
    height: -webkit-calc(23rem - 40px);
    background: #080a20;

    & > div {
      height: 100%;
    }
  }
}
</style>